import request from '../utils/request'
import qs from 'qs'
import { getTeamCode } from '@/utils/auth'
import { commonConfig } from '../utils/config'
const { apiHetaoDomain } = commonConfig

// 获取订单管理列表
export async function getOrderList(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/trail-orders`, params)
}

export async function getThirdTrialOrderList(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/third-trial-orders`, params)
}

export async function getThirdTrialOrderStatus() {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/third-order-status`)
}

export async function getStarOrder(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/boutique-orders`, params)
}

export async function getStatistics(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent/order/number?${qs.stringify(params)}`)
}

export async function getOrderAcc(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/orderAcc?${qs.stringify(params)}`)
}

export async function getCourseList(teamCodeList) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/course/team/list?teamCode=${getTeamCode()}&teamCodeList=${teamCodeList}`)
}

export async function getOrderSum(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/boutique-orders/sum`, params)
}

export async function getAgentManualOrders(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent-manual-orders/page`, params)
}

export async function setAgentManualOrders(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent-manual-orders`, params)
}

export async function getThirdOrder(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/third-orders`, params)
}

export async function getThirdPlatforms() {
  return request(`${apiHetaoDomain}/ug-agent-back/htinternal/v1/third/platforms`)
}

export async function getDorisTime() {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/doris-time?tableName=htcdm.dwd_mkt_third_party_order_relation_hdf`)
}

export async function getChannelGroup(teamCode) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/team/channelGroup/list?teamCode=${teamCode}`);
}

export async function queryChannelGroup(id) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/channel-group/${id}`);
}

export async function queryChannel(id) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/channel/${id}`);
}

export async function getThirdOrderUploadList(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/third-simple-batch/page?${qs.stringify(params)}`)
}

export async function downloadThirdOrderUploadFile(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/oss/download-urls?${qs.stringify(params)}`, {
    type: "POST"
  })
}

export async function downloadUploadTemplate() {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/third-simple-batch/thirdSimpleTemplate`)
}

export async function uploadThirdOrderUploadFile(params, file) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/third-simple-batch/simpleImport?${qs.stringify(params)}`, {
    type: "POST",
    params: file,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export async function getFailStatusList() {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent-manual-orders/failStatusList`);
}

export async function getAIOrderList(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent-manual-orders/page`, params);
}

export async function getChannelList() {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/course/channel/list?teamCode=${getTeamCode()}`);
}
